import styled from "styled-components";

export const HeroSection = styled.section`
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.background};
  box-shadow: inset 0 0 0 1000px rgba (0, 0, 0, 0.2);
  transition: background-color 0.3s ease-in;

  @media screen and (max-width: 1200px) {
    width: 100%;
    padding-top: 50px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;

export const HomeInfo = styled.div`
  padding: 40px 50px;

  .MainRow {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 40px;
    flex-wrap: wrap;
  }

  .TitleHome {
    text-align: center;
    font-size: 40px;
    font-weight: 500;
    line-height: 1.2;
    color: ${({ theme }) => theme.text};
    font-family: "Roboto", "Montserrat", "Instruments-sans", sans-serif;
    margin-bottom: 20px;
    width: 100%;
    max-width: 600px;

    .DescriptionSubtext {
      color: ${({ theme }) => theme.subtext};
      font-weight: 700;
    }
  }

  @media screen and (max-width: 1024px) {
    padding: 40px 30px;

    .MainRow {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .TitleHome {
      font-size: 28px;
      max-width: 350px;
      text-align: flex-start;
    }
  }
`;

export const CardHome = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 5rem auto 5rem auto;
  transition: background-color 0.3s ease-in;

  .TitleHome {
    font-size: 30px;
    font-weight: 600;
    color: ${({ theme }) => theme.text};
    margin-bottom: 10px;
    font-family: "Roboto", "Montserrat", "Instruments-sans", sans-serif;
    transition: background-color 0.3s ease-in;

    text-align: center;
  }

  @media screen and (max-width: 1024px) {
    .TitleHome {
      font-size: 30px;
      max-width: 350px;
      margin-bottom: 10px;
    }
  }
`;

export const ItemWrapper = styled.div`
  margin-top: 20px;
  height: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 1200px) {
    width: 100%;
    padding: 10px 0px 0px 0px;
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 1.5rem;
    padding: 0 20px;
  }

  @media (max-widh: 600px) {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 0 15px;
  }
`;
